import React from "react";
import FooterComponent from "../Component/Layout/Footer";
import { Outlet } from "react-router-dom";
import Header from "../Component/Layout/Header";
import SupportWidget from "../Component/Layout/SupportWidget";

const MainComponent = () => {
  return (
    <div>
      <Header />
      <Outlet />
      <FooterComponent />
      <SupportWidget />
    </div>
  );
};

export default MainComponent;
